import * as moment from 'moment';
import { MAX_CHARACTERS_DISPLAYED } from '../../constants/constants';

export const formatData = notifications =>
  notifications.map(notification => ({
    id: notification.id,
    title: notification.title,
    headerMessage: notification.headerMessage,
    createdAt: moment
      .utc(notification.createdUtc)
      .local()
      .fromNow(),
    content: notification.content,
    link: notification.link,
    status: notification.viewed ? 'read' : 'new',
    displayMore: notification.headerMessage.length > MAX_CHARACTERS_DISPLAYED // || notification.content.length > MAX_CHARACTERS_DISPLAYED
  }));

export default {
  formatData
};
